import * as Bouncer from "formbouncerjs";

import { BirthDateValidation } from "../utils/birthdateValidation";
import { emails } from "../utils/temporalEmails";

let BIRTH_DATE_VALIDATION;

Drupal.behaviors.mealsRegister = {
    attach: (context, settings) => {
        once('handler-back-errors', '.boxerror-input').forEach(field => {
            const input = field.querySelector('input');
            const error_message = field.querySelector('.error-input');
            input.addEventListener('input', function handler() {
                error_message?.remove();
                input.classList.remove('is-invalid', 'error');
                this.removeEventListener('input', handler);
            })

            sendErrorMessage(`input_${input?.name}`, error_message.textContent);
        })

        once('handler-form', '#co-clubco-meals-register').forEach(form => {
            let timer;
            const submit_button = form.querySelector('#edit-submit');

            const bouncer = new Bouncer(`#${form.id}`, {
                patterns: {
                    email:
                        /^[a-zA-Z0-9!#$%&'*/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/,
                },
                customValidations: {
                    onlyLetter: (field) => {
                        if (field.name == "name" || field.name == "lastname") {
                            let regex = /^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/.test(field.value)
                            return !regex
                        }
                    },
                    emailVerified: (field) => {
                        if (field.name == "email") {
                            let array_email = field.value.split("@");
                            const res = emails.find((m) => m === array_email[1]);
                            return res === undefined ? false : true;
                        }
                    },
                    minPass: ({ name, value }) => {
                        if (name == 'pass' || name == 'confirm_pass') {
                            if (value.length < 8) return true;
                        }
                    }
                },
                messages: {
                    missingValue: {
                        default: (e) => `${e.getAttribute('data-bouncer-required') || 'Campo obligatorio'}`,
                        checkbox: (e) => `${e.getAttribute('data-bouncer-required') || 'Debes marcar este campo'}`,
                    },
                    patternMismatch: {
                        email: "Por favor ingrese un email válido",
                    },
                    wrongLength: {
                        over: 'Por favor, acorte este texto a no más de {maxLength} caracteres. Actualmente está utilizando {length} caracteres',
                        under: 'Por favor, alargue este texto a {minLength} caracteres o más. Actualmente está utilizando {length} caracteres'
                    },
                    onlyLetter: "Solo se permiten letras",
                    emailVerified: "Por favor ingrese un email válido",
                    minPass: 'La contraseña debe ser de mínimo 8 dígitos'
                },
                disableSubmit: true
            });

            const inputs = [...form.querySelectorAll("input:not([type=checkbox])")];
            const checkboxes = [...form.querySelectorAll("input[type=checkbox]")];
            const selects = [...form.querySelectorAll("select")];

            inputs.forEach(input => {
                input.addEventListener('input', () => {
                    if (timer) clearTimeout(timer);
                    timer = setTimeout(() => {
                        if (inputs.every(i => i.value) && checkboxes.every(c => c.checked) && selects.every(s => s.value)) {
                            const isValid = bouncer.validateAll(form);
                            const isDateValid = BIRTH_DATE_VALIDATION.validate();
                            isValid.length === 0 && isDateValid.isValid ?
                                submit_button.classList.add('enable') :
                                submit_button.classList.remove('enable')
                        }
                        else submit_button.classList.remove('enable')
                    }, 200);
                });
            })

            checkboxes.forEach(checkbox => {
                checkbox.addEventListener('change', () => {
                    if (timer) clearTimeout(timer);
                    timer = setTimeout(() => {
                        if (inputs.every(i => i.value) && checkboxes.every(c => c.checked) && selects.every(s => s.value)) {
                            const isValid = bouncer.validateAll(form);
                            const isDateValid = BIRTH_DATE_VALIDATION.validate();
                            isValid.length === 0 && isDateValid.isValid ?
                                submit_button.classList.add('enable') :
                                submit_button.classList.remove('enable')
                        }
                        else submit_button.classList.remove('enable')
                    });
                });
            })

            selects.forEach(select => {
                select.addEventListener('change', () => {
                    if (timer) clearTimeout(timer);
                    timer = setTimeout(() => {
                        if (inputs.every(i => i.value) && checkboxes.every(c => c.checked) && selects.every(s => s.value)) {
                            const isValid = bouncer.validateAll(form);
                            const isDateValid = BIRTH_DATE_VALIDATION.validate();
                            isValid.length === 0 && isDateValid.isValid ?
                                submit_button.classList.add('enable') :
                                submit_button.classList.remove('enable')
                        }
                        else submit_button.classList.remove('enable')
                    });
                });
            })

            submit_button.addEventListener('click', () => {
                sendDatalayer({
                    'event_category': 'Form',
                    'event_action': 'Click',
                    'event_label': 'Send',
                    'interaction': 'true',
                    'component_name': 'Btn_continuar_registro_submit',
                    'campaign_description': 'Club_Colombia_Meals_Juego'
                });
            })
        });

        once('handler-password', '.js-form-type-password').forEach(passwordInput => {
            const input = passwordInput.querySelector('input');
            input.setAttribute('data-bouncer-target', `#error-${input.id}`);

            const wrapper = document.createElement('div');
            wrapper.classList.add('password-eye-wrapper');

            const eye = document.createElement('div');
            eye.classList.add('password-eye', 'password-eye--hide');

            const error_message = document.createElement('div');
            error_message.id = `error-${input.id}`;

            input.insertAdjacentElement('afterend', error_message);
            input.parentNode.insertBefore(wrapper, input);
            wrapper.appendChild(input);
            wrapper.appendChild(eye);

            eye.addEventListener('click', () => {
                if (input.type === 'password') {
                    input.type = 'text';
                    eye.classList.remove('password-eye--hide');
                } else {
                    input.type = 'password';
                    eye.classList.add('password-eye--hide');
                }
            })
        });

        once('handler-date', '#edit-container-date').forEach(dateWrapper => {
            BIRTH_DATE_VALIDATION = new BirthDateValidation('#edit-container-date', {
                fields: {
                    day: { selector: '#edit-day' },
                    month: { selector: '#edit-month' },
                    year: { selector: '#edit-year' }
                },
                messages: {
                    invalid: 'Debes seleccionar una fecha valida'
                }
            })

            let birthdayFields = BIRTH_DATE_VALIDATION.getFields();
            for (const name in birthdayFields) {
                birthdayFields[name]?.target?.addEventListener('change', () => {
                    BIRTH_DATE_VALIDATION.validate()
                })
            }
        })
    }
}

function sendDatalayer(options) {
    window.dataLayer ||= [];
    window.dataLayer.push({ 'event': 'GAEvent', ...options });
}

function sendErrorMessage(inputName, label) {
    sendDatalayer({
        'event_category': 'Form',
        'event_action': 'Error',
        'event_label': label,
        'interaction': 'true',
        'component_name': inputName,
    });
}

function validatePasswords(passwordField, confirmPassword) {
    if (!passwordField || !confirmPassword) return null;

    if (passwordField.value === confirmPassword.value) return true
    else return false
}

const password = document.getElementById('edit-pass'),
    confirm = document.getElementById('edit-confirm-pass');
let confirm_error = document.getElementById('error-edit-confirm-pass');
document.addEventListener('bouncerFormValid', (e) => {
    const form = e.target;
    let dateValidation = BIRTH_DATE_VALIDATION.validate();
    let isValid = validatePasswords(password, confirm);

    if (typeof isValid !== 'boolean') return;

    if (isValid && dateValidation.isValid) form.submit();
    else if (!isValid) {
        if (!confirm_error) confirm_error = document.getElementById('error-edit-confirm-pass');
        confirm_error.innerHTML = `<div class="error-message" id="bouncer-error_${confirm.name}">Las contraseñas no coinciden</div>`
        sendErrorMessage('input_password', 'Las contraseñas no coinciden')
    }
}, false);

document.addEventListener('bouncerShowError', (e) => {
    switch (e.target.id) {
        case 'edit-day': case 'edit-month': case 'edit-year':
            const customMandatory = document.querySelector('#custom-birth-date-error');
            const wrapper = document.querySelector('#edit-container-date');
            if (customMandatory) return
            wrapper?.insertAdjacentHTML('beforeend', `<div id="custom-birth-date-error" class="error-message">Debes seleccionar una fecha</div>`)
            break;
    }
})